// Build/version information.
//
// These values are baked into the JS bundle at build time by the Docker build
// (see nginx-proxy/Dockerfile and build-and-push-cve-fixed.bat). The running
// tab therefore always knows the exact build it was compiled from.
//
// At runtime the app polls the static /version.json file (which is replaced
// whenever a new image is deployed) and compares its buildHash against
// BUILD_HASH below. When they differ, a new version is live and the user is
// prompted to refresh. See hooks/useVersionCheck.js.

// Human-facing marketing version. Bump this in the build script (APP_VERSION)
// when you want the number shown in the footer to change.
export const APP_VERSION = process.env.REACT_APP_APP_VERSION || '0.9.5';

// Unique-per-build identifier: "<git short hash>-<timestamp>". Falls back to
// 'dev' during local `npm start` where no build arg is supplied.
export const BUILD_HASH = process.env.REACT_APP_BUILD_HASH || 'dev';

// ISO-ish build timestamp (yyyyMMddHHmmss) for reference/debugging.
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || '';

// What the footer shows, e.g. "Beta v0.9.5 · a1b2c3d".
export const VERSION_LABEL = `Beta v${APP_VERSION}${
  BUILD_HASH && BUILD_HASH !== 'dev' ? ` · ${BUILD_HASH.split('-')[0]}` : ''
}`;
